// The house game, "Play for your price" (game v2, 19 Sep 2026). Landing popup, PDP rail row
// (#pvGame [data-game-open]) and the header/menu Play entries all open this one dialog.
// ONE file for the static site and the theme: theme/assets/mz-game.js is a byte-identical copy.
//
// v415: the house game IS THE FLIGHT (js/house-flight.js). This dialog is its front door and its
// claim: it explains the flight, sends the player to it, and takes the result back for the prize.
// Free, no login, no form, unlimited flights. The RESULT is the server's, never the browser's: the
// finished flight is sent to the game server (worker/src/index.js, POST /play) with its seed and its
// input log, and the server replays it before it calls a win a win.
// Win = the Discovery Set, free (v456, 25 Sep). It was one bottle of the winner's choice: any of the 10 (Epos 60 ml, Oud 50 ml, Cristallo
// 50 ml) or the Epos Discovery Set. Pick from a grid ("I know") or through the scent finder
// (window.MZFinder, "Help me choose"). Everyone else = 10% off.
// Claim (win or 10%): +91 mobile -> 6-digit code on WhatsApp -> name + email (+ the house WhatsApp
// consent, optional) -> the server makes a single-use Shopify code -> "Apply and continue"
// (/discount/<CODE>?redirect=<product>). One prize per mobile number, ever: the server enforces it.
// No counter of any kind (founders, 19 Sep): no bottles-left, no claims number, nothing seeded.
//
// API = the game server's base URL: window.MZ.gameApi (theme setting "Game server URL").
// Empty on the static site = PREVIEW: the browser stands in for the server (preview() below) and
// the OTP step says so on screen. Empty on the live theme = the game is hidden, never simulated.
// Ring: starts full and DRAINS, green while high, red near zero; blind fade toward the target;
// performance.now() timing; a hidden tab voids the run.
(function () {
  // '' = static preview (the browser stands in for the server). The live theme sets window.MZ.gameApi;
  // on the review site, add ?api=1 to any page to talk to the real game server instead.
  var GAME_SERVER = 'https://mz-game.faiz-gemini109.workers.dev';
  var LOCAL = /^(localhost|127\.|0\.0\.0\.0)/.test(location.hostname);
  // the live server for the real site; the browser stands in for it locally, or with ?preview=1
  var API = (/[?&]preview=1/.test(location.search) || (LOCAL && !/[?&]api=1/.test(location.search))
    ? '' : ((window.MZ && window.MZ.gameApi) || GAME_SERVER)).replace(/\/$/, '');
  var THEME = !!(window.Shopify && window.Shopify.shop);
  if (THEME && !API) {                   // live store, no game server yet: no game rather than a pretend one
    [].forEach.call(document.querySelectorAll('[data-game-open], #navPlay, #menuPlay'), function (n) { n.hidden = true; });
    return;
  }
  // PREVIEW ONLY (static review site, API empty). These are NOT the live odds: the live game never
  // runs preview(). ?gamewin=1 forces a win; ?game=1 opens the game on load.
  var PREVIEW = { otp: '246810' };
  var TRY = 'mz-game-try', LAST = 'mz-game-claim', PCLAIMS = 'mz-game-preview-claims';
  var FORCE = /[?&]game=1/.test(location.search), FORCEWIN = /[?&]gamewin=1/.test(location.search);
  var EPOS = ['midsea-murmur', 'divine-dilemma', 'crown-cardinal', 'black-sunset', 'rich-reverie', 'rose-oclock'];
  var HOLD = 55 * 60e3;                   // a play token lives 60 min on the server; drop ours a little sooner
  function page(h) { return THEME ? '/pages/' + h : h + '.html'; }
  function load(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function save(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function ctx() {                        // the PDP rail row, when there is one (theme: data-url)
    var r = document.getElementById('pvGame'), d = (r && r.dataset) || {};
    return { url: d.url || location.pathname };
  }

  var attempt = null, session = null, stepName = '', busy = false;   // attempt = {tier, token, ts, choice}

  var DEMO = '<svg viewBox="0 0 160 150"><g class="d-walls"><rect class="d-smog" x="110" y="0" width="22" height="46" rx="8"/><rect class="d-smog" x="110" y="96" width="22" height="54" rx="8"/>' +
    '<rect class="d-smog" x="200" y="0" width="22" height="70" rx="8"/><rect class="d-smog" x="200" y="118" width="22" height="32" rx="8"/><path class="d-prize" d="M118 64h6v3h3a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3h-12a3 3 0 0 1-3-3v-9a3 3 0 0 1 3-3h3z"/></g>' +
    '<g class="d-flyer"><path class="d-line d-bottle" d="M-5 -12h10v4h4a4 4 0 0 1 4 4v14a4 4 0 0 1-4 4h-18a4 4 0 0 1-4-4V-4a4 4 0 0 1 4-4h4z"/></g></svg>';
  var el = document.createElement('div');
  el.className = 'mzg-overlay';
  el.setAttribute('role', 'dialog');
  el.setAttribute('aria-label', 'The house game');
  el.setAttribute('aria-modal', 'true');
  el.innerHTML =
    // v319: no hardcoded data-accent - the card inherits the page's perfume from <body>.
    '<div class="mzg-card">' +
      '<button class="mzg-x" aria-label="Close">×</button>' +
      '<h1 class="mzg-h1" id="mzgH1" aria-label="Play and win a Discovery Set">PLAY &amp; WIN A DISCOVERY SET</h1>' +
      '<div class="mzg-fly" id="mzgFlyWrap">' +
        '<div class="mzg-demo" aria-hidden="true">' + DEMO + '</div>' +
        // The break is authored, not left to the wrap: line one is the prize, line two is the floor.
        '<p class="mzg-say">Six scents, &#8377;1,949, on the house.<br>Play and 10% is yours either way.</p>' +
        '<ul class="mzg-facts"><li><b>5</b><span>minutes</span></li><li><b>3</b><span>lives</span></li><li><b>6</b><span>scents</span></li></ul>' +
        '<button type="button" class="mzg-btn mzg-apply mzg-fly-btn" id="mzgFly">Take&nbsp;&nbsp;off</button>' +
        '<button type="button" class="mzg-btn mzg-skip" id="mzgSkip">Never mind - just give me 10% now</button>' +
        '<p class="mzg-flynote">Five minutes, and genuinely hard. Take the 10% instead and the flight closes: one prize per person, either way.</p>' +
      '</div>' +
      '<div class="mzg-hint zetta" id="mzgHint" aria-live="polite"></div>' +
      '<div class="mzg-claim" id="mzgClaim" hidden>' +
        '<p class="mzg-result" id="mzgResult" aria-live="polite"></p>' +
        '<div class="mzg-step" data-s="know" hidden><p class="mzg-q">Do you know which one?</p><div class="mzg-acts">' +
          '<button type="button" class="mzg-btn mzg-apply" id="mzgIKnow">I know</button>' +
          '<button type="button" class="mzg-btn" id="mzgHelp">Help me choose</button></div></div>' +
        '<div class="mzg-step" data-s="grid"><p class="mzg-q">Choose your bottle</p><div class="mzg-grid" id="mzgGrid"></div>' +
          '<button type="button" class="mzg-link" data-pick="discovery-set">Or take the Discovery Set instead</button></div>' +
        '<p class="mzg-pick" id="mzgPick" data-s="mobile otp details"></p>' +
        '<form class="mzg-form" id="mzgForm" data-s="mobile otp details">' +
          '<span class="mzg-tel" data-s="mobile otp"><i>+91</i><input type="tel" id="mzgMobile" inputmode="numeric" autocomplete="tel-national" pattern="[6-9][0-9]{9}" placeholder="Mobile" aria-label="Mobile number" title="Enter a 10-digit Indian mobile number." required></span>' +
          '<input type="text" id="mzgOtp" data-s="otp" inputmode="numeric" autocomplete="one-time-code" pattern="[0-9]{6}" maxlength="6" placeholder="6-digit code" aria-label="The 6-digit code from WhatsApp" title="Enter the 6-digit code." required>' +
          '<p class="mzg-otpnote" id="mzgOtpNote" data-s="otp" aria-live="polite"></p>' +
          '<input type="text" id="mzgName" data-s="details" autocomplete="name" placeholder="Your name" aria-label="Your name" maxlength="80" required>' +
          '<input type="email" id="mzgEmail" data-s="details" autocomplete="email" placeholder="Your email" aria-label="Your email" spellcheck="false" required>' +
          '<label class="mzg-consent" data-s="details"><input type="checkbox" id="mzgWa" value="yes"><span>Send me WhatsApp messages from Maison Monzzaro about the house. Reply STOP at any time to leave. <a href="' + page('privacy') + '">Privacy Policy</a>.</span></label>' +
          '<p class="mzg-err" id="mzgErr" role="alert" hidden></p>' +
          '<button class="cta zetta" type="submit">Send&nbsp;&nbsp;code&nbsp;&nbsp;on&nbsp;&nbsp;WhatsApp</button>' +
        '</form>' +
        '<div class="mzg-code" id="mzgCode" data-s="done"></div>' +
        '<div class="mzg-acts" data-s="done"><a class="mzg-btn mzg-apply" id="mzgApply" href="#">Apply and continue</a>' +
          '<button type="button" class="mzg-btn" id="mzgCopy">Copy code</button></div>' +
        '<p class="mzg-note" id="mzgNote" data-s="done"></p>' +
        '<button type="button" class="mzg-btn mzg-again" id="mzgAgain" hidden>Fly&nbsp;&nbsp;again</button>' +
      '</div>' +
      '<p class="mzg-fine" id="mzgFine"></p>' +
    '</div>';

  function $(id) { return el.querySelector('#' + id); }
  var hint = $('mzgHint'), claim = $('mzgClaim'),
      result = $('mzgResult'), form = $('mzgForm'), codeBox = $('mzgCode'), note = $('mzgNote'), again = $('mzgAgain'),
      mobile = $('mzgMobile'), otpIn = $('mzgOtp'), otpNote = $('mzgOtpNote'), nameIn = $('mzgName'),
      emailIn = $('mzgEmail'), wa = $('mzgWa'), err = $('mzgErr'), pickLine = $('mzgPick'), grid = $('mzgGrid'),
      applyA = $('mzgApply');

  var ctaBtn = form.querySelector('.cta');

  function api(path, body) {
    if (!API) return new Promise(function (ok) { setTimeout(ok, 350); }).then(function () { return preview(path, body); });
    return fetch(API + path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok || j.error) throw j; return j; });
      }, function () { throw { error: 'network' }; });
  }
  function preview(path, b) {             // PREVIEW ONLY: mirrors the worker's answers, not its odds
    if (path === '/play') return { result: FORCEWIN || (b && b.won === true) ? 'win' : 'lose', token: 'preview' };
    if (path === '/flight/log') return { ok: true };
    if (path === '/otp/send') return { ok: true };
    if (path === '/otp/verify') { if (b.otp !== PREVIEW.otp) throw { error: 'otp' }; return { session: b.mobile }; }
    var all = load(PCLAIMS) || {}, held = all[b.session];   // /claim: one prize per number, this browser only
    if (held) return { code: held.code, tier: held.tier, choice: held.choice, repeat: true };
    held = all[b.session] = { tier: attempt.tier, choice: b.choice, code: 'PREVIEW-' + Math.random().toString(36).slice(2, 8).toUpperCase() };
    save(PCLAIMS, all);
    return held;
  }
  var ERR = {
    rate: 'Too many tries. Wait a few minutes, then try again.',
    otp: 'That code does not match. Check WhatsApp and try again.',
    expired_otp: 'That code has expired. Send a new one.',
    expired: 'This play has expired. Play again to claim.',
    used: 'This play has already been claimed. Play again.',
    busy: 'A claim for this number is already under way. Try again in a minute.',
    closed: 'The house game has closed. Thank you for playing.',
    gone: 'Every bottle has been claimed. Play again for 10% off.',
    mobile: 'Enter a 10-digit Indian mobile number.',
    details: 'Enter your name and a valid email address.',
    send: 'WhatsApp codes start tomorrow - your flight is recorded and your prize is held. Come back for the code.'
  };
  function errText(e) { return ERR[e && e.error] || 'The house could not be reached. Try again in a moment.'; }

  function lineOf(tier) {
    if (tier === 'win')
      return '<span class="mzg-r1">You flew the whole flight.</span>' +
        '<span class="mzg-r2">The Discovery Set is yours. Six scents, &#8377;1,949, on the house.</span>';
    // v457 (Faiz, 25 Sep): this line ran BEFORE the claim, so it promised a discount that was not on
    // the cart yet - the code does not exist until /claim returns one, and autoApply runs only then.
    // Say what is true at this moment: the 10% is won, the number is what puts it on the bag.
    return '<span class="mzg-r1">Grab Your 10% Discount!</span>' +
      '<span class="mzg-r2">Enter your mobile number to get your discount code and add it to your cart, ' +
      'so a closed tab cannot take it.<br>One prize per number only &mdash; fly again for the Discovery Set.</span>';
  }

  // The Flight calls this when it ends: window.MZGame.result(won, {seed, log}). The server replays
  // the log and has the last word on a win; in static preview the flight's own result stands.
  function fromFlight(won, proof) {
    openGame();
    if (won && tookTen()) {                        // cheeky: took the discount, then flew for a bottle anyway
      if (flyWrap) flyWrap.hidden = true;
      hint.hidden = true;
      claim.hidden = false;
      result.innerHTML = '<span class="mzg-r1">A beautiful flight - but you already took the 10%.</span>' +
        '<span class="mzg-r2">One prize per person, and you chose yours. The code you already have still works.</span>';
      step(''); again.hidden = false;
      return Promise.resolve();
    }
    hint.hidden = false; hint.textContent = won ? 'The house is checking your flight' : 'Your 10% is ready';
    return api('/play', { mode: 'flight', won: !!won, proof: proof || null }).then(function (r) {
      attempt = { tier: r.result === 'win' ? 'win' : '10', token: r.token, ts: Date.now(), choice: null };
      save(TRY, attempt); showResult();
    }, function (e) { hint.textContent = errText(e); claim.hidden = false; again.hidden = false; step(''); again.focus(); });
  }
  // v440: every ended flight tells the house how it went, win or lose, so the win rate is tuned from
  // real flights. Fire and forget - telemetry must never block or break the claim.
  function report(row) { api('/flight/log', row).catch(function () {}); }
  function showResult() {
    if (flyWrap) flyWrap.hidden = true;
    hint.hidden = true;
    claim.hidden = false;
    result.innerHTML = lineOf(attempt.tier);
    step(attempt.tier === 'win' && !attempt.choice ? 'know' : 'mobile');
  }

  // one step of the claim at a time: blocks carry data-s="<steps>"; inputs outside the step are
  // disabled, so native validation only checks what is on screen
  var CTA = { mobile: 'Send my code', otp: 'Verify', details: 'Send it to me' };
  function step(s) {
    stepName = s;
    [].forEach.call(el.querySelectorAll('[data-s]'), function (n) {
      var on = n.getAttribute('data-s').split(' ').indexOf(s) > -1;
      n.hidden = !on;
      if (/INPUT/.test(n.tagName)) n.disabled = !on;
      [].forEach.call(n.querySelectorAll('input'), function (i) { i.disabled = !on; });
    });
    mobile.readOnly = s === 'otp';
    err.hidden = true;
    again.hidden = !(s === 'done' || s === '' || (s === 'mobile' && attempt && attempt.tier !== 'win'));
    if (CTA[s]) ctaBtn.innerHTML = CTA[s].replace(/ /g, '&nbsp;&nbsp;');
    var p = attempt && attempt.choice && prod(attempt.choice);
    pickLine.innerHTML = '';
    if (p && s !== 'done') {
      pickLine.textContent = 'Your bottle: ' + p.name + ', ' + p.size + '. ';
      pickLine.insertAdjacentHTML('beforeend', '<button type="button" class="mzg-link" id="mzgChange">Change</button>');
    } else pickLine.hidden = true;
    var f = { know: '#mzgIKnow', grid: '.mzg-tile', mobile: '#mzgMobile', otp: '#mzgOtp', details: '#mzgName', done: '#mzgApply' }[s];
    f = f && el.querySelector(f);
    if (f && !f.offsetParent) f = $('mzgCopy');
    if (f && document.body.contains(el)) setTimeout(function () { f.focus({ preventScroll: false }); }, 30);
  }

  // ── the bottles: the scent finder's own data (js/scent-wizard.js, loaded on demand) ──
  function loadFinder(cb) {
    if (window.MZFinder) return cb();
    var s = document.createElement('script');
    s.src = THEME ? window.MZ.assetBase + 'mz-scent-wizard.js' : 'js/scent-wizard.js';
    s.onload = cb;
    s.onerror = function () { showErr({}); };
    document.head.appendChild(s);
  }
  function prod(slug) {
    var shop = (THEME && window.MZ.products && window.MZ.products[slug]) || {};
    if (slug === 'discovery-set')
      return { name: 'the Discovery Set', size: 'six Epos perfumes, 5 ml each', label: 'the Discovery Set',
               img: shop.image || 'img/pp-discovery-set.jpg', url: shop.url || (THEME ? '/products/discovery-set' : 'pdp-discovery-set.html') };
    var i = window.MZFinder && window.MZFinder.info && window.MZFinder.info(slug);
    if (!i) return { name: slug, size: '', label: slug, img: '', url: ctx().url };
    var epos = EPOS.indexOf(slug) > -1;
    return { name: i.name, label: 'one ' + i.name, size: i.coll.replace('La Collezione ', '') + (epos ? ' 60 ml' : ' 50 ml'),
             img: shop.image || i.img.replace(/(-light)?\.png$/, '.jpg'), url: i.url.replace(/#.*$/, '') };
  }
  function renderGrid() {
    if (grid.firstChild) return;
    grid.innerHTML = window.MZFinder.slugs.map(function (s) {
      var p = prod(s);
      return '<button type="button" class="mzg-tile" data-pick="' + s + '"><img src="' + p.img + '" alt="" loading="lazy">' +
        '<span>' + p.name + '</span><small>' + p.size + '</small></button>';
    }).join('');
  }
  function pick(slug) {
    attempt.choice = slug; save(TRY, attempt);
    step('mobile');
  }
  el.addEventListener('click', function (e) {
    var t = e.target.closest('[data-pick]');
    if (t && el.contains(t)) return pick(t.getAttribute('data-pick'));
    if (e.target.closest('#mzgChange')) return step('know');
  });
  $('mzgIKnow').addEventListener('click', function () { loadFinder(function () { renderGrid(); step('grid'); }); });
  var helpBtn = $('mzgHelp');
  helpBtn.addEventListener('click', function () {
    loadFinder(function () {
      window.MZFinder.open({ mode: 'claim', onPick: function (h) { pick(h); }, onDiscovery: function () { pick('discovery-set'); } });
    });
  });

  // ── claim: mobile -> WhatsApp code -> name + email -> code ──
  mobile.addEventListener('input', function () {          // digits only; tolerate a pasted +91 / leading 0
    var v = mobile.value.replace(/\D/g, '');
    if (v.length > 10 && v.slice(0, 2) === '91') v = v.slice(2);
    if (v.length === 11 && v.charAt(0) === '0') v = v.slice(1);
    mobile.value = v.slice(0, 10);
  });
  otpIn.addEventListener('input', function () { otpIn.value = otpIn.value.replace(/\D/g, '').slice(0, 6); });
  function showErr(e) { err.textContent = errText(e); err.hidden = false; }
  function otpSent() {
    otpNote.textContent = API ? 'We sent a 6-digit code to +91 ' + mobile.value + ' on WhatsApp. ' : '';
    if (!API) otpNote.insertAdjacentHTML('beforeend', '<b>Preview.</b> This review site sends no WhatsApp message. Enter ' + PREVIEW.otp + ' to continue. ');
    otpNote.insertAdjacentHTML('beforeend', '<button type="button" class="mzg-link" id="mzgResend">Send again</button> <button type="button" class="mzg-link" id="mzgRenum">Change number</button>');
  }
  otpNote.addEventListener('click', function (e) {
    if (e.target.id === 'mzgRenum') { otpIn.value = ''; step('mobile'); }
    if (e.target.id === 'mzgResend') run(api('/otp/send', { mobile: mobile.value, token: attempt.token }).then(function () {
      otpIn.value = ''; otpIn.focus();
    }));
  });
  function run(p) {
    busy = true; ctaBtn.disabled = true; err.hidden = true;
    return p.catch(showErr).then(function () { busy = false; ctaBtn.disabled = false; });
  }
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (busy || !attempt) return;
    if (Date.now() - attempt.ts > HOLD) return showErr({ error: 'expired' });
    if (stepName === 'mobile') run(api('/otp/send', { mobile: mobile.value, token: attempt.token }).then(function () { step('otp'); otpSent(); }));
    else if (stepName === 'otp') run(api('/otp/verify', { mobile: mobile.value, otp: otpIn.value, token: attempt.token }).then(function (r) {
      session = r.session; step('details');
    }));
    else if (stepName === 'details') run(api('/claim', { token: attempt.token, session: session, name: nameIn.value.trim(),
      email: emailIn.value.trim().toLowerCase(), consent: wa.checked, choice: attempt.choice }).then(claimed));
  });

  function claimed(r) {
    var c = { code: r.code, tier: r.tier, choice: r.choice || null };
    save(LAST, c); save(TRY, null);
    var p = c.tier === 'win' && c.choice ? prod(c.choice) : null, epos = !!p && EPOS.indexOf(c.choice) > -1;
    result.innerHTML = r.repeat ? '<span class="mzg-r1">This number already holds a prize from the house.</span><span class="mzg-r2">One prize per mobile number, so here it is again.</span>'
      : p ? '<span class="mzg-r1">The Discovery Set is on the house.</span><span class="mzg-r2">Six scents, 5 ml each, the whole of Act I.</span>'
      : '<span class="mzg-r1">Your 10% off.</span><span class="mzg-r2">One use, on any order.</span>';
    if (p && !r.repeat) result.lastChild.textContent = p.name + ', ' + p.size + '.';
    codeBox.textContent = c.code;
    var url = p ? p.url : ctx().url;
    applyA.href = THEME ? '/discount/' + encodeURIComponent(c.code) + '?redirect=' + encodeURIComponent(url) : url;
    step('done');
    applyA.hidden = epos;
    note.textContent = epos ? 'Epos releases mid-November 2026, with the preorders. Keep this code: it covers ' + p.label + ' 60 ml when the bottle is ready, and it is saved against your mobile number.'
      : p ? 'Apply it and ' + p.label + ' is free at checkout.'
      : 'Applying it to your bag...';
    if (!p && !epos) autoApply(c.code).then(function (ok) {
      note.textContent = ok ? 'Done - your 10% is on the bag already. It comes off at checkout.'
                            : 'Apply it and 10% comes off at checkout.';
      if (ok) applyA.textContent = 'Continue shopping';
    });
    if (!API) note.textContent += ' Preview: this code is a stand-in and works nowhere.';
    if (epos) $('mzgCopy').focus();
    railNote();
  }

  // v455 (Faiz, 25 Sep): a lost or abandoned flight should not ask for a second click. Shopify sets the
  // cart discount when /discount/<code> is fetched, so the 10% is already on the cart by the time the
  // player reads the line. Winners are NOT auto-applied: a free bottle is claimed deliberately, and the
  // code is mailed to them as well.
  function autoApply(code) {
    if (!THEME || !code) return Promise.resolve(false);
    return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .then(function (r) { return r.ok; }, function () { return false; });
  }
  $('mzgCopy').addEventListener('click', function () {
    var b = this, t = codeBox.textContent;
    (navigator.clipboard ? navigator.clipboard.writeText(t) : Promise.reject()).then(function () {
      b.textContent = 'Copied'; setTimeout(function () { b.textContent = 'Copy code'; }, 1800);
    }, function () {
      var r = document.createRange(); r.selectNodeContents(codeBox);
      var s = getSelection(); s.removeAllRanges(); s.addRange(r); b.textContent = 'Selected: press copy';
    });
  });
  function railNote() {                                    // the rail row shows this device's last code
    var n = document.getElementById('pvGameNote'), c = load(LAST);
    if (n && c && c.code) n.textContent = 'Your code ' + c.code;
  }

  // unlimited flights: back to the door
  function reset() {
    attempt = null; session = null; save(TRY, null);
    if (flyWrap) flyWrap.hidden = false;
    hint.hidden = true; hint.textContent = '';
    claim.hidden = true; result.innerHTML = ''; otpIn.value = '';
    if (flyBtn) flyBtn.focus();
  }
  again.addEventListener('click', reset);

  // ── the flight: this dialog only opens its door ──
  var flyWrap = $('mzgFlyWrap'), flyBtn = $('mzgFly'), skipBtn = $('mzgSkip');
  var TOOK = 'mz-took-ten';                       // this device chose the discount instead of the flight
  function tookTen() { try { return !!localStorage.getItem(TOOK); } catch (e) { return false; } }
  if (flyBtn) flyBtn.addEventListener('click', function () {
    if (tookTen()) { hint.hidden = false; hint.textContent = 'You already took the 10%. One prize per person.'; return; }
    location.href = page('game-flight');
  });
  if (skipBtn) skipBtn.addEventListener('click', function () {
    try { localStorage.setItem(TOOK, String(Date.now())); } catch (e) {}
    log10();
  });
  function log10() {                               // straight to the 10% claim, no flight
    if (flyWrap) flyWrap.hidden = true;
    hint.hidden = false; hint.textContent = 'Your 10% is ready';
    api('/play', { mode: 'skip', won: false }).then(function (r) {
      attempt = { tier: '10', token: r.token, ts: Date.now(), choice: null };
      save(TRY, attempt); showResult();
    }, function (e) { hint.textContent = errText(e); });
  }
  window.MZGame = { open: openGame, result: fromFlight, tookTen: tookTen, report: report };
  var opener = null;
  function close() {
    el.classList.remove('mzg-in');
    setTimeout(function () { el.remove(); }, 300);
    if (opener && opener.focus) opener.focus();
    opener = null;
  }
  // keyboard: Esc closes, Tab stays inside the card while it is open. On document, not the card, so
  // focus left on <body> (the finder overlay closed with Esc) is pulled back in; the finder, when
  // open above the game, handles its own keys.
  document.addEventListener('keydown', function (e) {
    if (!document.body.contains(el) || document.querySelector('.sw-ov')) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = [].filter.call(el.querySelectorAll('button,a[href],input:not([disabled]),[tabindex="0"]'), function (n) { return n.offsetParent; });
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (!el.contains(document.activeElement)) { e.preventDefault(); a.focus(); }
    else if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  });
  el.querySelector('.mzg-x').addEventListener('click', close);
  el.addEventListener('click', function (e) { if (e.target === el) close(); });

  // H1 in Six Caps, one line, with proximity SCALE-pressure. (Six Caps has no
  // variable axes, so true wght/wdth text-pressure is impossible; letters swell
  // toward the cursor instead — the closest honest port.)
  function pressureH1() {
    var h1 = $('mzgH1');
    var text = h1.textContent, letters = [];
    h1.textContent = '';
    for (var i = 0; i < text.length; i++) {
      var sp = document.createElement('span');
      sp.className = 'mzg-pl';
      sp.textContent = text[i] === ' ' ? '\u00a0' : text[i];   // nbsp: a plain space collapses to 0 width in an inline-block
      sp.setAttribute('aria-hidden', 'true');
      h1.appendChild(sp);
      letters.push(sp);
    }
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var RADIUS = 130, cur = { x: -1e4, y: 0 };
    h1.addEventListener('pointermove', function (e) { cur.x = e.clientX; cur.y = e.clientY; });
    h1.addEventListener('pointerleave', function () { cur.x = -1e4; });
    (function loop() {
      requestAnimationFrame(loop);
      for (var i = 0; i < letters.length; i++) {
        var r = letters[i].getBoundingClientRect();
        var d = Math.hypot(cur.x - (r.left + r.width / 2), cur.y - (r.top + r.height / 2));
        var f = d >= RADIUS ? 0 : 1 - d / RADIUS;
        letters[i].style.transform = 'scale(' + (1 + 0.55 * f).toFixed(3) + ')';
      }
    })();
  }

  var booted = false;
  function openGame() {
    if (!document.body.contains(el)) { opener = opener || document.activeElement; document.body.appendChild(el); }
    requestAnimationFrame(function () { el.classList.add('mzg-in'); });
    if (!booted) {
      booted = true;
      pressureH1();
      var fine = $('mzgFine');
      // the rules live in one place, Terms section 07; the popup only points there (Faiz, 21 Sep: the paragraph buried the buttons on a phone)
      fine.innerHTML = '<a href="' + page('terms') + '#sec-the-house-game">Read the Rules</a>';
      if (window.mzSpecularAttach) window.mzSpecularAttach(ctaBtn);
      // tilted-card effect on the CTA (softened: 6°, scale 1.03)
      ctaBtn.addEventListener('pointermove', function (ev) {
        var r = ctaBtn.getBoundingClientRect();
        var rx = ((ev.clientY - r.top - r.height / 2) / (r.height / 2)) * -6;
        var ry = ((ev.clientX - r.left - r.width / 2) / (r.width / 2)) * 6;
        ctaBtn.style.transform = 'perspective(40rem) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) scale(1.03)';
      });
      ctaBtn.addEventListener('pointerleave', function () { ctaBtn.style.transform = ''; });
      var a = load(TRY);                                   // played, not yet claimed: keep that result
      if (a && a.token && Date.now() - a.ts < HOLD) { attempt = a; showResult(); if (a.choice) loadFinder(function () { step('mobile'); }); }
      else save(TRY, null);
    }
    setTimeout(function () {                               // focus into the dialog (keyboard + screen readers)
      var f = [flyBtn, el.querySelector('.mzg-claim:not([hidden]) input:not([disabled]), .mzg-claim:not([hidden]) button:not([hidden])'), el.querySelector('.mzg-x')]
        .filter(function (n) { return n && n.offsetParent; })[0];
      if (f) f.focus();
    }, 60);
  }
  window.mzGameOpen = openGame;

  // nav entries + the PDP rail row open the game
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('#navPlay, #menuPlay, [data-game-open]');
    if (!t) return;
    e.preventDefault();
    opener = t;
    var mm = document.getElementById('mobileMenu'), b = document.getElementById('navBurger');
    if (mm && mm.classList.contains('open')) {
      mm.classList.remove('open');
      if (b) b.setAttribute('aria-expanded', 'false');
    }
    openGame();
  });

  // game CSS for the claim steps (kept here, so the theme copy carries it; same look as the newsletter §E)
  var css = document.createElement('style');
  css.textContent =
    '.mzg-form input{min-height:44px;box-sizing:border-box}' +
    '.mzg-tel{display:flex;align-items:center;width:100%;background:#FFFFFF}' +
    '.mzg-tel i{font-style:normal;padding:0 0 0 1rem;font-size:.875rem;color:var(--stone,#7a7672)}' +
    '.mzg-tel input{flex:1;min-width:0;padding-left:.5rem;text-align:left}' +
    '.mzg-tel input[readonly]{color:#6E6B77}' +
    '.mzg-consent{display:flex;align-items:flex-start;gap:.55rem;width:100%;text-align:left;font-size:.74rem;line-height:1.5;color:#FFFFFF;cursor:pointer}' +
    '.mzg-consent a{color:inherit;text-decoration:underline;text-underline-offset:.2em}' +
    '.mzg-consent input{accent-color:#FFFFFF;width:1rem;height:1rem;min-height:0;margin:.15rem 0 0;padding:0;flex:none}' +
    '.mzg-form input:user-invalid{outline:.125rem solid #B03348;outline-offset:0}' +
    '.mzg-dice[hidden],.mzg-ring[hidden],.mzg-stopat[hidden],.mzg-hint[hidden],.mzg-claim [hidden]{display:none}' +
    '.mzg-q{margin:0;font:800 .75rem/1.4 Inter,sans-serif;letter-spacing:.24em;text-transform:uppercase;color:#FFFFFF}' +
    '.mzg-step{display:flex;flex-direction:column;align-items:center;gap:.625rem;width:100%}' +
    '.mzg-acts{display:flex;gap:.625rem;width:100%}' +
    '.mzg-btn{flex:1;min-height:44px;display:inline-flex;align-items:center;justify-content:center;padding:.6rem 1rem;box-sizing:border-box;' +
      'font:800 .72rem/1.2 Inter,sans-serif;letter-spacing:.2em;text-transform:uppercase;text-decoration:none;cursor:pointer;' +
      'background:transparent;color:#FFFFFF;border:.0625rem solid rgba(255,255,255,.75)}' +
    '.mzg-btn:hover{border-color:#FFFFFF}' +
    '.mzg-apply{background:#FFFFFF;color:var(--h2,#141414);border-color:#FFFFFF}' +
    '.mzg-again{flex:none;align-self:center;min-width:10rem}' +
    '.mzg-link{background:none;border:0;padding:0 .15rem;min-height:44px;color:#FFFFFF;cursor:pointer;font:600 .8125rem Inter,sans-serif;text-decoration:underline;text-underline-offset:.2em}' +
    '.mzg-pick,.mzg-otpnote,.mzg-note{margin:0;font-size:.875rem;line-height:1.5;color:#FFFFFF}' +
    '.mzg-otpnote{text-align:left;width:100%}' +
    '.mzg-err{margin:0;width:100%;box-sizing:border-box;padding:.55rem .75rem;background:rgba(0,0,0,.3);color:#FFFFFF;font-size:.8125rem;line-height:1.45}' +
    '.mzg-grid{display:grid;grid-template-columns:repeat(5,1fr);gap:.5rem;width:100%}' +
    '.mzg-tile{display:flex;flex-direction:column;align-items:center;gap:.3rem;padding:0 0 .35rem;background:none;border:0;color:#FFFFFF;cursor:pointer;font:700 .6875rem/1.25 Inter,sans-serif;text-align:center}' +
    '.mzg-tile img{display:block;width:100%;aspect-ratio:1;object-fit:cover;object-position:50% 72%;background:#0A0A0A;outline:.0625rem solid rgba(255,255,255,.35);outline-offset:-.0625rem;transition:outline-color .2s}' +
    '.mzg-tile:hover img{outline-color:#FFFFFF}' +
    '.mzg-tile small{font-weight:500;font-size:.625rem;letter-spacing:.04em;opacity:.85}' +
    '.mzg-code{user-select:all;-webkit-user-select:all}' +
    '.mzg-x{min-width:44px;min-height:44px;top:.25rem;right:.25rem}' +
    '.mzg-card :focus-visible,.mzg-dice:focus-visible,.mzg-ring:focus-visible{outline:.125rem solid #FFFFFF;outline-offset:.25rem}' +
    '.mzg-fly{display:grid;justify-items:center;gap:1.1rem;margin:.4rem 0 .2rem}' +
    '.mzg-fly[hidden]{display:none}' +
    '.mzg-demo{width:100%;max-width:17rem;margin:0 auto;border:.0625rem solid rgba(255,255,255,.28);background:rgba(0,0,0,.22)}' +
    '.mzg-demo svg{display:block;width:100%;height:auto}' +
    '.mzg-demo *{transform-box:fill-box}' +
    '.mzg-demo .d-line{fill:none;stroke:#FFF;stroke-width:2}' +
    '.mzg-demo .d-smog{fill:rgba(255,255,255,.34)}' +
    '.mzg-demo .d-prize{fill:#FFF;animation:dPrize 4s infinite}' +
    '.mzg-demo .d-walls{animation:dScroll 4s linear infinite}' +
    '.mzg-demo .d-flyer{animation:dFly 4s ease-in-out infinite}' +
    '.mzg-demo .d-bottle{fill:rgba(255,255,255,.18)}' +
    '@keyframes dScroll{from{transform:translateX(20px)}to{transform:translateX(-160px)}}' +
    '@keyframes dFly{0%{transform:translate(44px,92px)}10%{transform:translate(44px,78px)}20%{transform:translate(44px,62px)}30%{transform:translate(44px,56px)}40%{transform:translate(44px,64px)}50%{transform:translate(44px,72px)}' +
      '60%{transform:translate(44px,66px)}68%{transform:translate(44px,76px)}78%{transform:translate(44px,84px)}88%{transform:translate(44px,90px)}94%{transform:translate(44px,96px)}100%{transform:translate(44px,92px)}}' +
    '@keyframes dPrize{0%,40%{opacity:1}46%,100%{opacity:0}}' +
    '.mzg-say{font-family:\'Six Caps\',sans-serif;font-weight:400;font-size:clamp(2.4rem,8vw,3.6rem);line-height:.92;letter-spacing:.02em;' +
      'text-transform:uppercase;margin:1rem 0 .9rem;color:#FFF}' +
    '.mzg-facts{list-style:none;display:flex;justify-content:center;gap:2.2rem;margin:0 0 1.4rem;padding:0}' +
    '.mzg-facts li{display:grid;gap:.2rem}' +
    '.mzg-facts b{font-size:1.5rem;font-weight:800;line-height:1;color:#FFF}' +
    '.mzg-facts span{font-size:.58rem;font-weight:700;letter-spacing:.2em;text-transform:uppercase;color:rgba(255,255,255,.72)}' +
    '.mzg-fly-btn{min-width:12rem}' +
    '.mzg-skip{background:transparent;color:#FFF;box-shadow:inset 0 0 0 1px rgba(255,255,255,.45);min-width:12rem;font-size:.62rem}' +
    '.mzg-skip:hover{background:rgba(255,255,255,.1)}' +
    '.mzg-flynote{margin:0;max-width:26rem;font-size:.74rem;line-height:1.55;color:rgba(255,255,255,.72);text-align:center}' +
    '.mzg-card .mzg-fine{font-size:.75rem;letter-spacing:.14em;text-transform:uppercase;opacity:.9}' +
    '.mzg-fine a{color:inherit;text-decoration:underline;text-underline-offset:.2em}' +
    // the claim state outgrows the fixed-ratio card; centred overflow would clip the title
    '.mzg-card{justify-content:safe center}' +
    '@media (max-width:34rem){.mzg-card{aspect-ratio:auto}.mzg-grid{grid-template-columns:repeat(3,1fr)}}' +
    '@media (max-width:40rem){.mzg-form input,.mzg-tel i{font-size:16px}}' +   // 16px: no iOS zoom on focus
    '@media (prefers-reduced-motion:reduce){.mzg-tile img{transition:none}}';
  document.head.appendChild(css);

  railNote();
  // auto-show once per visitor; hero paints first. Never on an intent surface (preorder form, #preorder).
  // never on the flight's own page: there the game IS the page, and this card would sit on top of it
  var ON_FLIGHT = !!document.getElementById('ptGame');
  // No first-visit popup (Faiz, 21 Sep): the game opens only when asked for - header icon, menu, the product page's button - or by the ?game=1 test URL.
  if (!ON_FLIGHT && (FORCE || FORCEWIN)) setTimeout(openGame, 1400);
})();
